const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  seeAll: "Ver todo",
  clear: "Eliminar",
  back: "Atrás",
  save: "Guardar",
  close: "Cerrar",
  of: "De",
  to: "A",
  copyrights: "© {date} Bridgestone. Todos los derechos reservados.",
  pageNotFound: "Página no encontrada",
  accessDenied: "Acceso denegado",
  search: "Buscar",
  year: "Año",
  buttons: {
    loading: "Cargando...",
    export: "Exportar",
    delete: "Eliminar",
    save: "Guardar",
    cancel: "Cancelar",
    next: "Siguiente",
    back: "Atrás",
    skip: "Saltar",
    send: "Enviar",
    clear: "Borrar",
    close: "Cerca",
    readNow: "Lee ahora",
    pointsList: "Lista de puntos",
    more: "Más",
    reportError: "Informar error",
    accept: "Aceptar",
    download: "Descargar",
    downloadAll: "Descargar todo",
    selectAll: "Seleccionar todo",
    deselectAll: "Deseleccionar todo",
    downloadSelection: "Descargar selección",
    dealerInfoDownload: "Descargar",
    toTheBasket: "Añadir a la cesta",
    toOrderDelivery: "Continuar a la dirección de entrega",
    discover: "Descubrir",
    newAddress: "Agregar nueva dirección de entrega",
    selectAddressBtn: "Selecciona tu dirección de entrega",
    toOrderSummary: "Ir al resumen del pedido",
    placeOrder: "Confirmar pedido",
    toDashboard: "Ir a la página de inicio",
    newOrder: "Nuevo pedido",
    userOrders: "IR A MIS PEDIDOS",
    toSearch: "Buscar",
    select: "Seleccionar",
    moreCustomerNumbers: "+ AÑADIR MÁS NÚMEROS DE CLIENTE",
    loadMore: "Cargar más",
    toStaffDashboard: "Al panel",
    toQuiz: "Al cuestionario",
    vouchers: "Vales",
    exchangeVoucher: "Canjear código de vale",
    confirm: "Confirmar",
    sharePoints: "Compartir puntos",
    create: "Crear",
    update: "Actualizar",
    toBDrive: "A B-Drive",
    preview: "Vista previa",
    clickHere: "Ver detalles",
    setFilters: "Por favor, establezca <b>como máximo un filtro por columna</b>",
    all: "Todos",
  },
  tooltips: {
    info: "¿Necesitas ayuda?",
  },
  confirmation: {
    header: "Confirmación necesaria",
    message: "¿Deseas eliminar esta entrada?",
  },
  nav: {
    consents: "Consentimientos",
    dashboard: "Inicio",
    accountDashboard: "Panel",
    account: "Mi Perfil",
    mailbox: "Bandeja de entrada",
    singleMailbox: "Mensajes",
    stammdaten: "Mis datos",
    news_feeds: "Noticias",
    pointsOverview: "Mis puntos",
    rewardsOverview: "Mis puntos",
    about: "Todo sobre BRIDGESTONE",
    service_number: "Contactos y Servicios",
    shop: "Tienda de regalos",
    salesPromotions: "Promociones de ventas",
    promotions: "Mi cuenta",
    shopCategory: "Tienda de regalos",
    productDetails: "Detalles del producto",
    userOrders: "Mis pedidos",
    shoppingCart: "Carro de la compra",
    orderDelivery: "Dirección de envío",
    orderSummary: "Resumen del pedido",
    orderComplete: "Pedido finalizado",
    text_page: "Página estática",
    staff: "Panel de servicio",
    onlineTrainings: "Formaciones online",
    trainings: "Formaciones",
    training: "Formación",
    trainingForm: "Formulario de formación",
    staffVouchers: "Vales",
    wholesalerVouchers: "Vales",
    brochure_prices: "Listas de precios y folletos",
    investment: "Apoyo a la inversion",
    media: "Medios",
    medias: "Medios",
    contact_service: "Contacto y Servicio",
    productInfo: "INFORMACIÓN DEL PRODUCTO",
    bDrive: "Imágenes de productos",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Condiciones de participación",
    first_stop: "Garantía de neumáticos Bridgestone",
    payouts: "Payouts",
},
  breadcrumbs: {
    dashboard: "Inicio",
    accountDashboard: "Panel",
    account: "Mi Perfil",
    mailbox: "Bandeja de entrada",
    singleMailbox: "Mensajes",
    stammdaten: "Mis datos",
    news_feeds: "Noticias",
    pointsOverview: "Mis puntos",
    rewardsOverview: "Mis puntos",
    about: "Todo sobre BRIDGESTONE",
    service_number: "Contactos y Servicios",
    shop: "Tienda de regalos",
    salesPromotions: "Promociones de ventas",
    promotions: "Mi cuenta",
    shopCategory: "Tienda de regalos",
    productDetails: "Detalles del producto",
    userOrders: "Mis pedidos",
    shoppingCart: "Carro de la compra",
    orderDelivery: "Dirección de envío",
    orderSummary: "Resumen del pedido",
    orderComplete: "Pedido finalizado",
    staff: "Panel de servicio",
    onlineTrainings: "Formaciones online",
    trainings: "Formaciones",
    training: "Formación",
    trainingForm: "Formulario de formación",
    staffVouchers: "Vales",
    wholesalerVouchers: "Vales",
    brochure_prices: "Listas de precios y folletos",
    investment: "Apoyo a la inversion",
    media: "Medios",
    medias: "Medios",
    contact_service: "Contacto y Servicio",
    productInfo: "INFORMACIÓN DEL PRODUCTO",
    bDrive: "Imágenes de productos",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Condiciones de participación",
    first_stop: "Garantía de neumáticos Bridgestone",
    payouts: "Payouts",
},
  menu: {
    account: "Mi Perfil",
    plus: 'Sobre Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Soporte de Ventas",
    mailbox: "Bandeja de entrada",
    about: "Todo sobre BRIDGESTONE",
    trainingAndCourses: "Formación  y Cursos",
    externalTraining: "Formación Externa",
    productInfo: "Información del Producto",
    productBrochures: "Folletos de Productos",
    priceLists: "Listas de Precios",
    price: "Precio",
    complaintForm: "Formulario de Quejas",
    sales_support: "Soporte de Ventas",
    contact_service: "Contacto y Servicio",
    logOut: "Cerrar sesión",
    news: "Noticias",
    news_feeds: "Noticias",
    service_number: "Contactos y Servicios",
    salesPromotions: "Promociones de ventas",
    shop: "Tienda de regalos",
    onlineTrainings: "Formaciones online",
    trainings: "Formaciones",
    brochure_prices: "Listas de precios y folletos",
    media: "Medios",
    medias: "Medios",
    stammdaten: "Mis datos",
    preislisten: "Listas de Precios",
  },
  validation: {
    requiredField: "Campo obligatorio",
  },
  makeChoice: "Selecciona un distribuidor",
  sortBy: {
    default: "Ordenar por",
    desc: "Ordenar por: Más recientes",
    asc: "Ordenar por: Más antiguos",
    name: "Nombre",
    date: "Fecha",
    choiceBy: "Ordenar",
  },
  month: {
    1: "enero",
    2: "febrero",
    3: "marzo",
    4: "abril",
    5: "mayo",
    6: "junio",
    7: "julio",
    8: "agosto",
    9: "septiembre",
    10: "octubre",
    11: "noviembre",
    12: "diciembre"
  },
};


export default {
  messages,
};
